import { isOrderCancellable, OrderState } from '@printdeal/business-logic';
import { SanitizedOrder } from '../../../../../../types/order/Order';
import { Environment } from '../../../../../../helpers/env';

const ReasonsDisabled = {
  CANNOT_BE_CANCELLED: 'The order cannot be cancelled due to it\'s state or absence of uncancelled lineItems.',
};

const canCancelOrderHelper = (order: SanitizedOrder) => {
  if (!isOrderCancellable(Environment, order.state as OrderState, order.lineItems)) {
    return {
      enabled: false,
      reasonDisabled: ReasonsDisabled.CANNOT_BE_CANCELLED,
    };
  }

  return {
    enabled: true,
  };
};

export default canCancelOrderHelper;
